__turbopack_context__.v({
  "actionButton": "bYszgW_actionButton",
  "activeHeading": "bYszgW_activeHeading",
  "activeHeadingText": "bYszgW_activeHeadingText",
  "productListContainer": "bYszgW_productListContainer",
  "qrModalContainer": "bYszgW_qrModalContainer",
  "qrModalDownloadButton": "bYszgW_qrModalDownloadButton",
  "rearrangeButtons": "bYszgW_rearrangeButtons",
  "rearrangeButtonsContainer": "bYszgW_rearrangeButtonsContainer",
  "rearrangeButtonsContainerThrift": "bYszgW_rearrangeButtonsContainerThrift",
  "rearrangeModeActiveButton": "bYszgW_rearrangeModeActiveButton",
  "seeMoreText": "bYszgW_seeMoreText",
  "sellerLikesUsername": "bYszgW_sellerLikesUsername",
  "shopDropWrapper": "bYszgW_shopDropWrapper",
});
